// libs
import React from 'react';
import { Link } from 'react-router-dom';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { TextButton } from '@swiggy-private/dls-web-core/dist/components/TextButton';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './index.module.scss';
export default function IndexPage() {
    return (React.createElement("div", { className: styles.container },
        React.createElement("img", { src: "https://partner.swiggy.com/public/img/404.png", className: styles.banner }),
        React.createElement(Text, { variant: DlsFontVariants.header_H2_Black, color: DlsColorTokens.text_High_Emphasis }, "OOPS the page that you are looking for is not found on this server"),
        React.createElement(Link, { to: "/", className: styles.link },
            React.createElement(TextButton, { buttonSize: "medium", onClick: () => undefined, color: DlsColorTokens.primary }, "Go to Dashboard"))));
}
